var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-content__tabs global__fade-in-up",attrs:{"id":_vm.id}},[_c('div',{ref:"tabs",staticClass:"dont-print",attrs:{"role":"tablist"},on:{"keydown":_vm.handleKeyDown}},[_vm._t("tabs")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }